export const UNDELETE_TABLES='UNDELETE_TABLES'
export const UNDELETE_TABLES_SUCCESS= 'UNDELETE_TABLES_SUCCESS'
export const UNDELETE_TABLES_ERROR= 'DELETE_TABLES_ERROR'

export const UnDeleteTables= (data) => ({
    type: UNDELETE_TABLES,
    payload: data
});
